import React from 'react';
import PropTypes from 'prop-types';

import {IconSettings16} from 'pac-ux-components';

import {I18n} from '@aws-amplify/core';

import {AiOutlineHome, AiOutlineInfoCircle} from 'react-icons/ai';

import {NavLink} from 'react-router-dom';

import {Group} from '@mantine/core';

export const PageFooter = ({
    homeLabel,
    homePath,
    aboutLabel,
    aboutPath,
    signinOptionsLabel,
    signinOptionsPath,
}) => (
    <Group position="center" mt="xl">
        <NavLink to={homePath}>
            <Group spacing="sm">
                <AiOutlineHome />
                {I18n.get(homeLabel)}
            </Group>
        </NavLink>

        <NavLink to={aboutPath}>
            <Group spacing="sm">
                <AiOutlineInfoCircle />
                {I18n.get(aboutLabel)}
            </Group>
        </NavLink>

        <NavLink to={signinOptionsPath}>
            <Group position="center" spacing="sm">
                <IconSettings16 />
                {I18n.get(signinOptionsLabel)}
            </Group>
        </NavLink>
    </Group>
);

PageFooter.propTypes = {
    homeLabel: PropTypes.string,
    homePath: PropTypes.string,
    aboutLabel: PropTypes.string,
    aboutPath: PropTypes.string,
    signinOptionsLabel: PropTypes.string,
    signinOptionsPath: PropTypes.string,
};

PageFooter.defaultProps = {
    homeLabel: 'Home',
    homePath: '/',
    aboutLabel: 'About',
    aboutPath: '/about',
    signinOptionsLabel: 'Sign-in Options',
    signinOptionsPath: '/signin-options',
};
